const RANKING_ITEMS = [
  {
    rank: 1,
    title: '长安风云录 第二季',
    tag: '古装权谋',
    heat: '本周播放量 3,280万',
    trend: 'up',
  },
  {
    rank: 2,
    title: '极限追击',
    tag: '动作大片',
    heat: '本周播放量 2,860万',
    trend: 'up',
  },
  {
    rank: 3,
    title: '迷雾追踪',
    tag: '悬疑犯罪',
    heat: '本周播放量 2,540万',
    trend: 'up',
  },
  {
    rank: 4,
    title: '盛夏光年',
    tag: '爱情治愈',
    heat: '本周播放量 2,180万',
    trend: 'new',
  },
  {
    rank: 5,
    title: '星际迷航记',
    tag: '科幻巨制',
    heat: '本周播放量 1,960万',
    trend: 'same',
  },
];

const TREND_ICONS: Record<string, string> = {
  up: 'ri-arrow-up-line text-primary-500',
  new: 'ri-sparkling-line text-accent-500',
  same: 'ri-subtract-line text-foreground-400',
};

export default function Ranking() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-950">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-background-50">热门榜单</h2>
          <p className="mt-2 text-sm text-foreground-400">本周最受欢迎的影视作品排行</p>
        </div>

        <div className="max-w-[700px] mx-auto">
          {RANKING_ITEMS.map((item, idx) => (
            <div
              key={idx}
              className={`flex items-center gap-4 p-4 md:p-5 rounded-xl transition-all duration-300 cursor-pointer ${
                idx < 3
                  ? 'bg-background-800/50 hover:bg-background-800 border border-background-700/30'
                  : 'hover:bg-background-800/30 border border-transparent hover:border-background-700/20'
              } ${idx < RANKING_ITEMS.length - 1 ? 'mb-2' : ''}`}
            >
              <div className={`w-10 h-10 rounded-xl flex items-center justify-center shrink-0 font-heading text-lg ${
                idx === 0 ? 'bg-accent-500 text-background-950' :
                idx === 1 ? 'bg-secondary-400 text-background-950' :
                idx === 2 ? 'bg-secondary-300 text-background-950' :
                'bg-background-700 text-foreground-300'
              }`}>
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <h3 className="font-heading text-sm md:text-base text-background-50">{item.title}</h3>
                  <i className={`${TREND_ICONS[item.trend]} text-sm`}></i>
                </div>
                <div className="flex items-center gap-2 mt-1">
                  <span className="text-xs text-foreground-500">{item.tag}</span>
                  <span className="text-xs text-foreground-500">·</span>
                  <span className="text-xs text-foreground-400">{item.heat}</span>
                </div>
              </div>

              <button className="shrink-0 w-10 h-10 rounded-lg bg-primary-500/20 hover:bg-primary-500/40 flex items-center justify-center transition-colors cursor-pointer">
                <i className="ri-play-fill text-primary-400 text-lg"></i>
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}